export enum ColorSettings {
  NEW_DRAW_AVAILABLE_COLOR = "NewDrawAvailableColor",
  NEW_DRAW_REQUEST_COLOR = "NewDrawRequestColor",
  NEW_INSPECTION_REQUEST_COLOR = "NewInspectionRequestColor",
  PROJECT_LOCKED_COLOR = "ProjectLockedColor",
  TBD_PROJECT_COLOR = "TBDProjectColor",
  NEW_FILES_AVAILABLE_COLOR = "NewFilesAvailableColor",
  PROJECT_IMPORTED_COLOR = "ProjectImportedColor",
  PROJECT_DECLINED_COLOR = "ProjectDeclinedColor",
  DRAW_APPROVED_COLOR = "DrawApprovedColor",
}

export function getColorSettingDisplayText(setting: ColorSettings | string | null) {
  if (!setting) return "";

  switch (setting) {
    case ColorSettings.NEW_DRAW_AVAILABLE_COLOR:
      return "New Draw Available";
    case ColorSettings.NEW_DRAW_REQUEST_COLOR:
      return "New Draw Request";
    case ColorSettings.NEW_INSPECTION_REQUEST_COLOR:
      return "New Inspection Request";
    case ColorSettings.PROJECT_LOCKED_COLOR:
      return "Project Locked";
    case ColorSettings.TBD_PROJECT_COLOR:
      return "TBD Project";
    case ColorSettings.NEW_FILES_AVAILABLE_COLOR:
      return "New Files Available";
    case ColorSettings.PROJECT_IMPORTED_COLOR:
      return "Project Imported";
    case ColorSettings.PROJECT_DECLINED_COLOR:
      return "Project Declined";
    case ColorSettings.DRAW_APPROVED_COLOR:
      return "Draw Approved";
    default:
      return "";
  }
}
